import { lazy, Suspense } from 'react';
import { z } from 'zod';
import { TrendingUp } from 'lucide-react';
import { Skeleton } from '@/components/ui/skeleton';
import { useDashboardMetric } from '@/hooks/use-dashboard-metric';
import type { TileDefinition } from './types';

/**
 * Lazy import — Recharts is code-split so the non-dashboard bundle stays
 * slim (same pattern as `throughput-trend`).
 */
const OutboundTrendTile = lazy(() =>
  import('../outbound-trend-tile').then((m) => ({ default: m.OutboundTrendTile }))
);

export const outboundTrendTile: TileDefinition = {
  type: 'outbound_call_trend',
  title: 'Outbound call trend',
  description: 'Daily calls and dispositions over the selected range.',
  icon: TrendingUp,
  metrics: ['outbound_call_trend'],
  defaultSize: { w: 6, h: 4 },
  minSize: { w: 4, h: 3 },
  configSchema: z.object({}).strict(),
  defaultConfig: {},
  render: ({ period, enabled }) => {
    const { metric, isLoading, isError } = useDashboardMetric({
      metricKey: 'outbound_call_trend',
      from: period.from,
      to: period.to,
      enabled,
    });
    return (
      <Suspense
        fallback={
          <div className="flex h-full min-h-0 flex-col gap-2">
            <Skeleton className="h-3 w-40" />
            <Skeleton className="min-h-0 flex-1" />
          </div>
        }
      >
        <OutboundTrendTile data={metric?.items} isLoading={isLoading} isError={isError} />
      </Suspense>
    );
  },
};
